import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { ApiRequestPost } from "../../../../../../data/network/services/ApiRequestPost";
import { SUCCESS } from "../../../../../../utility/Constants";
import ResizeListener from "../../../../../../utility/ResizeListener";
import { updateClientbalance } from "../../../../../../utility/services/balanceServices";
import CustomModal from "../../../../../components/customModal/CustomModal";
import { BlackClear } from "../../../../../resources/assetsManager";
import { BG_COLOR, WHITE_COLOR } from "../../../../../resources/colorsManager";
import EditBeneficiary from "../../edit_beneficiary";
import BeneficiarySendOtp from "../individual/BeneficiarySendOtp";
import SendMoneyBeneficiary from "./SendMoneyBeneficiary";
function SendMoneyToBeneIndex({
  beneficiaryDetails,
  onClose,
  onSuccess,
  isEditRequired = false,
  balance,
}) {
  const { width } = ResizeListener();
  const [step, setStep] = useState(0);
  const [amount, setAmount] = useState("");
  const [transferType, setTransferType] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [beneficiaryName, setBeneficiaryName] = useState("");
  const dispatch = useDispatch();

  const verifyOtp = (otp) => {
    setLoading(true);
    ApiRequestPost.verifyOtpForBeneficiary({
      otp,
    })
      .then((response) => {
        if (response.status === SUCCESS) {
          onClickSendMoney();
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
        onClose();
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: "error",
        });
        onClose();
      })
      .finally(() => {
        setLoading(false);
        onClose();
      });
  };

  const sendOtp = (amount) => {
    setLoading(true);
    ApiRequestPost.sendOtpForBeneficiary({
      amount,
    })
      .then((response) => {
        if (response.status === SUCCESS) {
          setStep(1);
          enqueueSnackbar(response.message, {
            variant: "success",
          });
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        enqueueSnackbar(error.message, {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onClickSendMoney = (amount, transferType) => {
    setLoading(true);
    ApiRequestPost.addBeneficiaryAndSendMoney({
      accountNumber,
      amount,
      type: transferType,
      beneficiaryName,
      ifscCode,
    })
      .then((response) => {
        if (response.status === SUCCESS) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          onSuccess();
          dispatch(updateClientbalance());
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        enqueueSnackbar(error.message, {
          variant: "error",
        });
      })
      .finally((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setBeneficiaryName(beneficiaryDetails?.beneficiaryName);
    setIfscCode(beneficiaryDetails?.ifscCode);
    setAccountNumber(beneficiaryDetails?.accountNumber);
  }, [beneficiaryDetails]);

  useEffect(() => {
    dispatch(updateClientbalance());
  }, []);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        marginTop: 20,
        padding: "20px 20px",
        backgroundColor: WHITE_COLOR,
        minWidth: 330,
        borderRadius: 7,
        width: width * 0.35,
        height: "100%",
        alignItems: "center",
        paddingBottom: 0,
        maxWidth: 400,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <p
          style={{
            fontSize: 18,
            fontWeight: "600",
            width: "100%",
            textAlign: "center",
          }}
        >
          {step === 0 ? "Enter Amount" : step === 1 ? "Enter the OTP" : ""}
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: BG_COLOR,
            padding: 10,
            borderRadius: 6,
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          <img src={BlackClear} />
        </div>
      </div>
      {step === 0 ? (
        <>
          <SendMoneyBeneficiary
            accountNumber={accountNumber}
            ifsc={ifscCode}
            name={beneficiaryName}
            onClickSubmit={(val) => {
              const { transferType, amount } = val;
              setAmount(amount);

              setTransferType(transferType);
              if (Number(balance) / 100 >= Number(amount)) {
                // sendOtp(amount);
                onClickSendMoney(amount, transferType);
              } else {
                enqueueSnackbar("Insufficient balance", {
                  variant: "error",
                });
              }
            }}
            loading={loading}
            onClickEdit={() => {
              setOpenEditModal(true);
            }}
            isEditRequired={isEditRequired}
          />
        </>
      ) : step === 1 ? (
        <BeneficiarySendOtp
          onClickConfirm={(otp) => {
            verifyOtp(otp);
          }}
          loading={loading}
        />
      ) : (
        <></>
      )}

      {openEditModal && (
        <CustomModal
          open={openEditModal}
          onClose={() => {
            setOpenEditModal(false);
          }}
        >
          <EditBeneficiary
            onClose={() => {
              setOpenEditModal(false);
            }}
            onClickSubmit={(val) => {
              setBeneficiaryName(val?.beneficiaryname);
              setIfscCode(val?.ifscCode);
              setAccountNumber(val?.accountNumber);
              setOpenEditModal(false);
              console.log(val, "val");
            }}
          />
        </CustomModal>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    balance: state.BalanceReducer.clientBalance,
  };
};
export default connect(mapStateToProps)(SendMoneyToBeneIndex);
